import { SetupAnalysisResult } from "@/types/agent";
import { AgentCacheManager } from "./AgentCacheManager";
import { AgentMapper } from "./AgentMapper";
import { AgentProvisionService, type CloneOptions } from "./AgentProvisionService";
import { AgentQueryService, type AgentFilters } from "./AgentQueryService";

export class AgentService {
  public static async getUserAgentsIds() {
    return AgentCacheManager.getUserAgentsIds();
  }

  public static invalidateUserAgentsCache() {
    AgentCacheManager.invalidateCache();
  }

  public static async getAgents(cursor?: string, limit: number = 30, isAdmin: boolean = false, userId?: string, filters?: AgentFilters) {
    return AgentQueryService.getAgents(cursor, limit, isAdmin, userId, filters);
  }

  public static async getAgentDetails(id: number | string) {
    return AgentQueryService.getAgentDetails(id);
  }

  public static async fixSignatureContacts(id: string) {
    return AgentQueryService.fixSignatureContacts(id);
  }

  public static async list(searchName?: string, userId?: string) {
    return AgentQueryService.list(searchName, userId);
  }

  public static async listMarketplaceGenies() {
    return AgentQueryService.listMarketplaceGenies();
  }

  public static async create(analysis: SetupAnalysisResult) {
    return AgentProvisionService.create(analysis);
  }

  public static async update(agent: any, updates: any) {
    return AgentProvisionService.update(agent, updates);
  }

  public static async deleteAgent(agentId: string | null, dbAgentId: string) {
    return AgentProvisionService.delete(agentId, dbAgentId);
  }

  public static async duplicateAgent(
    agentId: string,
    customName?: string,
    promptReplacements?: { from: string; to: string }[],
    userId?: string,
    options?: CloneOptions,
  ) {
    return AgentProvisionService.duplicateAgent(agentId, customName, promptReplacements, userId, options);
  }

  public static async reorder(sort: Record<string, number>) {
    return AgentQueryService.reorder(sort);
  }

  public static async ensureAdminAgentsActive(userId: string) {
    return SubscriptionManager.ensureAdminAgentsActive(userId);
  }

  public static map(data: any) {
    return AgentMapper.map(data);
  }
}

// Export sub-modules for advanced use
export { AgentQueryService } from "./AgentQueryService";
export { AgentProvisionService, type CloneOptions, type CloneReport } from "./AgentProvisionService";
export { AgentCacheManager } from "./AgentCacheManager";
export { AgentMapper } from "./AgentMapper";
export { personaToCreateParams } from "./QuickCreateService";
export { PronunciationService } from "./PronunciationService";
